import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { PrestamosModel } from './prestamos.model';
import { PrestamosFormComponent } from './prestamos-form.component';
import { PrestamosService } from './prestamos.service';

@Component({
    selector: 'convfact-dialog-import-account-prestamos',
    templateUrl: './prestamos-dialog-importAccount.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})
export class PrestamosDialogImportAccount implements OnInit {

    dataImport: PrestamosModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<PrestamosFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public prestamosService: PrestamosService,
        public sharedService: SharedService
    ) { }

    ngOnInit(){
    }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "Prestamo").then(result => {
            this.dialogRef.close(); 
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
